import { useEffect } from 'react';
import { useAuthContext } from '@/lib/AuthContext';
import { trackArticleClick } from '@/lib/analytics';
import { Article } from '@/types/article';

export function useTrackArticleView(article?: Article) {
    const { user } = useAuthContext();

    useEffect(() => {
        if (article && article.id) {
            // Track the view after a small delay to ensure page is interactive
            const timeout = setTimeout(() => {
                trackArticleClick(
                    Number(article.id),
                    article.naslov,
                    article.kategorija,
                    article.podkategorija,
                    article.podpodkategorija,
                    user?.email ?? undefined
                );
            }, 500);

            return () => clearTimeout(timeout);
        }
    }, [article?.id, article?.naslov, article?.kategorija, article?.podkategorija, article?.podpodkategorija, user?.email ?? undefined]);
}

export default useTrackArticleView;
